var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", style: { minHeight: 60 + "vh" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(" Distributior email configuration "),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("on-close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c(
                "b-tag",
                {
                  staticClass: "mb-2",
                  attrs: { type: "is-info", size: "is-medium", rounded: "" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.distributor.id) +
                      " - " +
                      _vm._s(_vm.distributor.name) +
                      " "
                  ),
                ]
              ),
              _c(
                "b-tag",
                { attrs: { type: "is-info", size: "is-medium", rounded: "" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.distributor.address || "") +
                      " " +
                      _vm._s(_vm.distributor.city) +
                      ", " +
                      _vm._s(_vm.distributor.country) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("b-loading", {
            attrs: { "is-full-page": false },
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          }),
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("ValidationObserver", {
                ref: "observer",
                attrs: { tag: "form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ valid }) {
                      return [
                        _c(
                          "b-field",
                          { attrs: { label: "Start date", horizontal: "" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-datepicker", {
                                          attrs: {
                                            placeholder: "Click to select...",
                                            icon: "calendar-days",
                                            "trap-focus": "",
                                            rounded: "",
                                          },
                                          model: {
                                            value: _vm.selectedDate,
                                            callback: function ($$v) {
                                              _vm.selectedDate = $$v
                                            },
                                            expression: "selectedDate",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "Language", horizontal: "" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              placeholder: "select a language",
                                              rounded: "",
                                            },
                                            model: {
                                              value: _vm.selectedLang,
                                              callback: function ($$v) {
                                                _vm.selectedLang = $$v
                                              },
                                              expression: "selectedLang",
                                            },
                                          },
                                          _vm._l(
                                            _vm.languages,
                                            function (lang) {
                                              return _c(
                                                "option",
                                                {
                                                  key: lang,
                                                  domProps: { value: lang },
                                                },
                                                [
                                                  _vm._v(
                                                    " " + _vm._s(lang) + " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "Template", horizontal: "" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              placeholder: "Click to select...",
                                              expanded: "",
                                              rounded: "",
                                            },
                                            model: {
                                              value: _vm.selectedTemplate1,
                                              callback: function ($$v) {
                                                _vm.selectedTemplate1 = $$v
                                              },
                                              expression: "selectedTemplate1",
                                            },
                                          },
                                          _vm._l(
                                            _vm.templates,
                                            function (template) {
                                              return _c(
                                                "option",
                                                {
                                                  key: template.id,
                                                  domProps: {
                                                    value: template.id,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(template.name) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "2nd", horizontal: "" } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  placeholder: "Click to select...",
                                  expanded: "",
                                  rounded: "",
                                },
                                model: {
                                  value: _vm.selectedTemplate2,
                                  callback: function ($$v) {
                                    _vm.selectedTemplate2 = $$v
                                  },
                                  expression: "selectedTemplate2",
                                },
                              },
                              _vm._l(_vm.templates, function (template) {
                                return _c(
                                  "option",
                                  {
                                    key: template.id,
                                    domProps: { value: template.id },
                                  },
                                  [_vm._v(" " + _vm._s(template.name) + " ")]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "3rd", horizontal: "" } },
                          [
                            _c(
                              "b-select",
                              {
                                attrs: {
                                  placeholder: "Click to select...",
                                  expanded: "",
                                  rounded: "",
                                },
                                model: {
                                  value: _vm.selectedTemplate3,
                                  callback: function ($$v) {
                                    _vm.selectedTemplate3 = $$v
                                  },
                                  expression: "selectedTemplate3",
                                },
                              },
                              _vm._l(_vm.templates, function (template) {
                                return _c(
                                  "option",
                                  {
                                    key: template.id,
                                    domProps: { value: template.id },
                                  },
                                  [_vm._v(" " + _vm._s(template.name) + " ")]
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "Circle (d)", horizontal: "" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            placeholder: "30",
                                            rounded: "",
                                          },
                                          model: {
                                            value: _vm.inputFrequency,
                                            callback: function ($$v) {
                                              _vm.inputFrequency = $$v
                                            },
                                            expression: "inputFrequency",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            attrs: {
                              label: "Send to",
                              message: "use , to seperate multiple emails",
                              horizontal: "",
                            },
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            placeholder: "john@client.com",
                                            rounded: "",
                                          },
                                          model: {
                                            value: _vm.inputEmail,
                                            callback: function ($$v) {
                                              _vm.inputEmail = $$v
                                            },
                                            expression: "inputEmail",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          { attrs: { label: "Send from", horizontal: "" } },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: true } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-input", {
                                          attrs: { rounded: "" },
                                          model: {
                                            value: _vm.sendFrom,
                                            callback: function ($$v) {
                                              _vm.sendFrom = $$v
                                            },
                                            expression: "sendFrom",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          {
                            attrs: { horizontal: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            position: "is-right",
                                            dashed: "",
                                            multilined: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "content",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " When files are uploaded, notifications will be sent to these email addresses as well as the sender's address. "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [_vm._v(" Notification ")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { rules: { required: false } },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ errors }) {
                                      return [
                                        _c("b-input", {
                                          attrs: {
                                            placeholder:
                                              "peter@fr-gps.com,alice@fr-gps.com",
                                            rounded: "",
                                          },
                                          model: {
                                            value: _vm.inputCC,
                                            callback: function ($$v) {
                                              _vm.inputCC = $$v
                                            },
                                            expression: "inputCC",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm.showStatus
                          ? _c(
                              "b-field",
                              { attrs: { label: "Status", horizontal: "" } },
                              [
                                _c(
                                  "b-select",
                                  {
                                    attrs: { rounded: "" },
                                    model: {
                                      value: _vm.inputStatus,
                                      callback: function ($$v) {
                                        _vm.inputStatus = $$v
                                      },
                                      expression: "inputStatus",
                                    },
                                  },
                                  _vm._l(
                                    ["Active", "Pending", "Inactive"],
                                    function (option) {
                                      return _c("option", { key: option }, [
                                        _vm._v(" " + _vm._s(option) + " "),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "mt level-right" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "button is-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: !valid,
                                  loading: _vm.isLoading,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.submit.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v(" Save ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }